import { AB_SIMILAR_MATERIAL_LIST } from "@/constants/ABMng";
import { useABTestWithCache } from "@/utils/hooks/useABtest";
import { createContext, ReactNode, useContext } from "react";

interface PinDetailContextValue {
  relatedBoardsList?: any;
  boardMatchingResult?: any;
  isNewUser?: boolean;
  onUserBoardUpdate?: (board: any) => void;
  enableBoardRecommend?: boolean;
  flagValue?: {
    hbPinDetailFeedFlag: boolean;
    similarMaterialListFlag: string;
  };

  similarMaterialListAB?: {
    loading: boolean;
    value: string;
    horizontal_1: boolean;
    horizontal_2: boolean;
    old: boolean;
  };
}

const PinDetailContext = createContext<PinDetailContextValue>({});

interface PinDetailProviderProps {
  children: ReactNode;
  value: PinDetailContextValue;
}

export function PinDetailProvider({ children, value }: PinDetailProviderProps) {
  const { flagValue } = value;

  // 相似素材ab实验
  const similarMaterialListAB = useABTestWithCache({
    ...AB_SIMILAR_MATERIAL_LIST,
    defaultValue:
      flagValue?.similarMaterialListFlag ||
      AB_SIMILAR_MATERIAL_LIST.defaultValue,
  });

  return (
    <PinDetailContext.Provider value={{ ...value, similarMaterialListAB }}>
      {children}
    </PinDetailContext.Provider>
  );
}

export function usePinDetailContext() {
  return useContext(PinDetailContext);
}
